import Sheet, { TSheetSize } from "components/sheet/Sheet";
import React, { ReactNode } from "react";

export interface IBuilderSettingsSheetProps {
  open?: boolean;
  title: string;
  supportText?: string;
  size: TSheetSize;
  okText?: string;
  cancelText?: string;
  secondaryText?: string;
  okDisabled?: boolean;
  secondaryDisabled?: boolean;
  onOk: () => void;
  onCancel: () => void;
  onSecondary?: () => void;
  children: ReactNode;
}

export function BuilderSettingsSheet(props: IBuilderSettingsSheetProps) {
  const {
    open = true,
    title,
    supportText,
    size,
    okText,
    cancelText,
    secondaryText,
    okDisabled,
    secondaryDisabled,
    onOk,
    onCancel,
    onSecondary,
    children,
  } = props;

  return (
    <Sheet
      open={open}
      title={title}
      supportText={supportText}
      size={size}
      okText={okText}
      cancelText={cancelText}
      secondaryText={secondaryText}
      okDisabled={okDisabled}
      secondaryDisabled={secondaryDisabled}
      onOk={onOk}
      onCancel={onCancel}
      onSecondary={onSecondary}
      backDropCancel={false}
      closable
    >
      {children}
    </Sheet>
  );
}
